export default class Search {
	constructor() {
		this.initEvents();
	}

    initEvents() {
        if (!document.querySelector('.search-page')) {
            this.showSearchButton();
        }
        this.fillSearchBar();
	}

    /**
     * Fill search bar with "q" url param
     */
	fillSearchBar() {
        const url = new URL(window.location.href);
        var sanitizeHTML = function (str) {
          var temp = document.createElement('div');
          temp.textContent = str;
          return temp.innerHTML;
        };
        if (url.searchParams.has('q') && url.searchParams.get('q')) {
            document.getElementsByClassName('search-result-title')[0].innerHTML = `<span>${window.jsTranslations['search_result_message']} </span> ${sanitizeHTML(url.searchParams.get('q'))}`;
        }
    }

    /**
     * Show validate button when you begin to write in search bar
     */
    showSearchButton() {
        let searchbars = document.querySelectorAll('.search-bar');

        for(let searchbar of searchbars) {
            let input = searchbar.querySelector('.search-input');
            let button = searchbar.querySelector('.search-button');

            input.addEventListener('keyup',() => {
                if(input.value !== "") {
                    button.classList.add('enable');
                } else {
                    button.classList.remove('enable');
                }
            });

            if(document.getElementsByClassName('short-header') && document.getElementsByClassName('header').length === 0) {
                button.classList.add('search-page-button');
            }
        }
    }
}
